import React, { useState, useContext, useEffect } from 'react';

import { api } from './components/api';
import { useFetchMovies } from './useFetchMovies';
import { useAuth0 } from '@auth0/auth0-react';

// this will give us access to Provider which we pass in props
const AppContext = React.createContext();
const Context = ({ children }) => {
  const [myList, setMyList] = useState([]);
  const [allMovies, setAllMovies] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [showToast, setShowToast] = useState({
    heading: '',
    msg: '',
    isShowing: false,
  });

  const { isAuthenticated } = useAuth0();

  // Grab movies, loadingState and hero immage from our custom hook
  const { movies, trending, isLoading, heroHome, trailers } = useFetchMovies(
    api.discover
  );

  useEffect(() => {
    setAllMovies((prev) => (prev = [...movies, ...trending, ...searchResults]));
    let timer;

    if (showToast.isShowing) {
      timer = setTimeout(() => {
        setShowToast({
          heading: '',
          msg: '',
          isShowing: false,
        });
      }, 4000);
    }

    if (timer) {
      return () => {
        clearTimeout(timer);
      };
    }
  }, [movies, setAllMovies, trending, searchResults, showToast.isShowing]);

  // searchForMovie
  const searchForMovie = (resultsArray) => {
    setSearchResults((prev) => {
      return [...prev, ...resultsArray];
    });
  };

  // remove from list
  const removeFromList = (id) => {
    const updatedList = myList.filter((movie) => movie.id !== id);
    setMyList((prev) => (prev = updatedList));
    setShowToast({
      heading: 'success',
      msg: `movie removed from your list`,
      isShowing: true,
    });
  };

  // My list state
  const addToList = (id) => {
    if (isAuthenticated) {
      const org = myList.find((item) => item.id === id);
      let selectedMovie;
      if (!org) {
        selectedMovie = allMovies.find((movie) => movie.id === id);
        setMyList((prevList) => {
          return prevList ? [...prevList, selectedMovie] : [selectedMovie];
        });

        setShowToast({
          heading: 'success',
          msg: `${selectedMovie.title} added to your list`,
          isShowing: true,
        });
      } else {
        setShowToast({
          heading: 'error',
          msg: 'You have already added that movie to your list',
          isShowing: true,
        });

        return;
      }
    } else {
      setShowToast({
        heading: 'error',
        msg: 'You need to login to add a movie to your list',
        isShowing: true,
      });
    }
  };

  return (
    <AppContext.Provider
      value={{
        movies,
        trending,
        isLoading,
        heroHome,
        trailers,
        addToList,
        removeFromList,
        myList,
        searchForMovie,
        showToast,
        setShowToast,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { Context, AppContext };
